import { ScrutinyTab } from '../ScrutinyTab';
import { Button } from 'primereact/button';
import React, { useEffect, useRef, useState } from 'react';
import { Toast } from 'primereact/toast';
import { getAllDetails, postAllData } from '../../../service/ProductService';
import { CHECKDUPLICATE, SAVESCRUTINY, SCRUTINY_VERIFICATION_STAGE, SEARCHAPPLICATIONS, SEARCHSCRUTINY } from '../../../config/ApiConstant';
import { transferApplicationName, convertDateFrom, transfertoGujApplicationNo, transfertoDDDNH } from '../../../appconfig/Settings';
import { convertDateTime, formatDate, formatMonth, setScrutinyActiveTab } from '../../../appconfig/AppHelper';
import { useNavigate, useParams } from 'react-router-dom';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { combinedFullNameTemplate, dateTemplate } from '../../../appconfig/DatatableTemplateSetting';
import { Badge } from 'primereact/badge';
import { Dialog } from 'primereact/dialog';
import Loader from '../../../components/Loadeer/Loader';
import FormWizard from 'react-form-wizard-component';
import 'react-form-wizard-component/dist/style.css';
import { Checkbox } from 'primereact/checkbox';
import ScrutinyHoldModal from '../../../components/Modal/ScrutinyHoldModal';
import ScrutinyPermanentCloseModal from '../../../components/Modal/ScrutinyPermanentCloseModal';
import { RadioButton } from 'primereact/radiobutton';
import ScrutinySuccessModal from '../../../components/Modal/ScrutinySuccessModal';
import { InputTextarea } from 'primereact/inputtextarea';
import AppBreadcrumb from '../../../components/CustomeBreadcrumb/AppBreadcrumb';
import { InputText } from 'primereact/inputtext';
import { Calendar } from 'primereact/calendar';
import ScrutinyVerificationModal from '../../../components/Modal/ScrutinyVerficationModal';

export const TrasnferToDDDNHScrutinySteps = () => {
    document.title = 'Transfer To  DD/DNH  Scrutiny | GSPC';

    //Set Toast/ Filter Properties
    const toast = useRef<any>(null);
    const navigate = useNavigate();

    //scrutinyRemainingList

    const [applicationDetails, setApplicationDetails] = useState<any>({});
    const [scrutinyDetails, setScrutinyDetails] = useState<any>({});
    const [selectedExitExam, setSelectedExitExam] = useState<any>(null);

    //duplicateata
    const [duplicateData, setDuplicateData] = useState<any>([]);
    const [duplicateModal, setDuplicateModal] = useState<any>(false);

    //tabIndex
    const [activeIndex, setActiveIndex] = useState<any>();

    //role
    const [roleName, setRoleName] = useState<any>(null);

    //name
    const [userName, setUserName] = useState<string>('');

    //loaders
    const [pageLoad, setPageLoad] = useState<boolean>(true);

    //scrutiny hold dialog
    const [scrutinyHoldDialog, setScrutinyHoldDialog] = useState<boolean>(false);
    const [scruitnyPermanentCloseDialog, setScruitnyPermanentCloseDialog] = useState<boolean>(false);
    const [certificateDialog, setCertificateDialog] = useState<boolean>(false);
    const [approveConfirmDialog, setApproveConfirmDialog] = useState<boolean>(false);
    const [approveBtnLoader, setApproveBtnLoader] = useState<boolean>(false);
    const [openVerificationDialog, setOpenVerificationDialog] = useState<boolean>(false);

    //selectedCertificate
    const [selectedCertificate, setSelectedCertificate] = useState<any>(null);
    const [date, setDate] = useState<any>();

    const [saveButtonLoader, setSaveButtonLoader] = useState<boolean>(false);
    const [successDialog, setSuccessDialog] = useState<boolean>(false);
    const [successDetails, setSuccessDetails] = useState<any>({});

    const { status, fileNo }: any = useParams();

    //specifiv Year
    const [specificYear] = useState<any>(new Date(2022, 0));

    useEffect(() => {
        // Get Token from LocalStorage
        let token: any = localStorage.getItem('token');
        let role: any = localStorage.getItem('role');
        let name: any = localStorage.getItem('name');

        //Token Decode
        if (!window.cn(token)) {
            const { myUserObject } = JSON.parse(window.atob(token.split('.')[1]));
            if (!window.cn(role)) {
                let roleNm = role;
                let selectedTab = activeIndex === 0 ? setScrutinyActiveTab(roleNm) : atob(status);
                setActiveIndex(Number(selectedTab));
                setRoleName(roleNm);
                setUserName(name);

                if (!window.cn(fileNo)) {
                    let fileNumber: any = atob(fileNo);
                    searchScrutiny(fileNumber);
                }
            }
        }
    }, [status]);

    //seasr serutiny api
    const searchScrutiny = async (fileNo: any) => {
        try {
            setPageLoad(true);

            const response = await getAllDetails(SEARCHAPPLICATIONS + '?SrNo=' + fileNo + '&applicationTypeName=' + transferApplicationName);
            if (response) {
                // const JoingYth = new Date(response?.JoingYth).getFullYear() >= specificYear.getFullYear();

                // if (JoingYth === true && response?.DegNm === 'D Pharm') {
                //     setSelectedExitExam('1');
                // } else {
                //     setSelectedExitExam('0');
                // }

                setApplicationDetails(response);

                try {
                    const innerResponse = await getAllDetails(SEARCHSCRUTINY + '?EntryNo=' + fileNo + '&applicationTypeName=' + transferApplicationName);
                    if (innerResponse) {
                        setScrutinyDetails(innerResponse);

                        setDate(new Date(innerResponse?.LtrDt));
                    }
                } catch (error: any) {
                    if (error.response) {
                        //Spinner False and Set Toast
                        toast.current?.show({ severity: 'error', summary: 'Error', detail: 'Could Not Load Data' });
                    }
                }

                setPageLoad(false);
            }

            //find duplicate
            checkDuplicate(fileNo);

            //
        } catch (error: any) {
            if (error.response) {
                //Spinner False and Set Toast
                setPageLoad(false);
                toast.current?.show({ severity: 'error', summary: 'Error', detail: 'Could Not Load Data' });
            }
        }
    };

    //handle change
    const handleChange = (e: any, name: string) => {
        let checked;
        if (e.checked === true) {
            checked = 1;
        } else {
            checked = 0;
        }
        let val = checked;
        setScrutinyDetails({ ...scrutinyDetails, [name]: val });
    };

    // handle change date
    const handleChangeDate = (val: any) => {
        setDate(val);
    };

    //handleNoteChnage
    const handleNoteChange = (e: any, name: string) => {
        let val = (e.target && e.target.value) || e.value || '';
        setScrutinyDetails({ ...scrutinyDetails, [name]: val });
    };
    //certificateChange
    const onCertificateChange = (e: any) => {
        setSelectedCertificate(e);
    };

    //certificateChange
    const onExitExamChange = (e: any) => {
        setSelectedExitExam(e);
    };

    //find duplicate
    const checkDuplicate = async (fileNo: any) => {
        try {
            if (!window.cn(fileNo)) {
                // this.setState({ fileNumber: fileNo });
                const response = await getAllDetails(CHECKDUPLICATE + '/' + fileNo);
                if (response) {
                    setDuplicateData(response);
                } else {
                    setDuplicateData([]);
                }
            }
        } catch (error: any) {
            if (error.response) {
                //Spinner False and Set Toast
                setDuplicateData([]);
            }
        }
    };

    // hidedupliactedialog
    const hideDuplicateDialog = () => {
        setDuplicateModal(false);
    };

    //const hideScrutinyHoldDialog
    const hideScrutinyHoldDialog = () => {
        setScrutinyHoldDialog(false);
    };

    //const hideScrutinyPermanentCloseDialog
    const hideScrutinyPermanentCloseDialog = () => {
        setScruitnyPermanentCloseDialog(false);
    };

    //const hideScrutinyPermanentCloseDialog
    const closeApproveConfirmDialog = () => {
        setApproveConfirmDialog(false);
    };

    //openCertificateModal
    const openCertificateModal = () => {
        setCertificateDialog(true);
    };

    //closeCertificateModal
    const hideCertificateModal = () => {
        setCertificateDialog(false);
    };

    //const hideScrutinyPermanentCloseDialog
    const closeVerificationModal = () => {
        setOpenVerificationDialog(false);
    };

    //saveScrutiny
    const saveScrutiny = async () => {
        try {
            setSaveButtonLoader(true);

            let allData = { ...scrutinyDetails };

            //Request Data
            let requestData = allData;
            requestData['EntryNo'] = atob(fileNo);
            requestData['applicationTypeName'] = transferApplicationName;

            if (roleName == 'Scrutiny Manager') {
                requestData['prepared_by'] = userName;
            }

            if (roleName == 'Sub Registar') {
                requestData['checked_by'] = userName;
            }

            if (roleName == 'Registar') {
                requestData['Cert'] = selectedCertificate.toString();
                requestData['approved_by'] = userName;
            }

            if (!window.cn(date)) {
                requestData['LtrDt'] = convertDateFrom(date);
            }

            const response = await postAllData(SAVESCRUTINY, requestData);
            if (response) {
                setSuccessDetails(response);
                setSaveButtonLoader(false);
                setCertificateDialog(false);
                setScrutinyDetails({});
                setSelectedCertificate(null);
                successDetailfn();
            }
        } catch (error: any) {
            if (error.response) {
                setSaveButtonLoader(false);

                toast.current?.show({ severity: 'error', summary: 'Error', detail: 'Something Went Wrong' });
            }
        }
    };

    const successDetailfn = () => {
        if (successDetails && !window.cn(successDetails)) {
            setTimeout(() => {
                setSuccessDialog(true);
            }, 1000);
        }
    };

    // Modal Goto App Call
    const goToApp = () => {
        setSuccessDialog(false);
        navigate(`/app/scrutiny/transfer-to-dd-dnh-scrutiny/${btoa(activeIndex)}`);
    };

    // Get Name
    let name = `${!window.cn(applicationDetails?.StudL) ? applicationDetails?.StudL : ''} ${!window.cn(applicationDetails?.StudF) ? applicationDetails?.StudF : ''} ${!window.cn(applicationDetails?.StudM) ? applicationDetails?.StudM : ''}`;

    //
    const sendToVerification = async () => {
        try {
            setApproveBtnLoader(true);

            //Request Data
            let requestData = {
                AppId: transfertoDDDNH,
                SrNo: atob(fileNo)
            };

            //Api Call
            const response = await postAllData(SCRUTINY_VERIFICATION_STAGE, requestData);
            if (response) {
                closeApproveConfirmDialog();
                toast.current?.show({ severity: 'success', summary: 'Success', detail: response?.message });
                setTimeout(() => {
                    navigate(`/app/scrutiny/transfer-to-dd-dnh-scrutiny/${btoa(activeIndex)}`);
                }, 1500);
            }
        } catch (error: any) {
            if (error.response) {
                //Spinner False and Set Toast
                setApproveBtnLoader(false);
                toast.current?.show({ severity: 'error', summary: 'Error', detail: 'Could Not Load Data' });
            }
        }
    };
    //go to  VerificationList
    const viewVerificationList = (fileNo: any, innerpage: any) => {
        let docUrl = `/app/scrutiny/verificationList/${window.btoa(fileNo)}`;
        innerpage === '' ? navigate(docUrl) : window.open(docUrl, '_blank');
    };

    //view documensts
    const viewDocuments = () => {
        const docUrl = `/app/scrutiny/viewDocument/${fileNo}/${window.btoa(transferApplicationName)}`;
        window.open(docUrl, '_blank');
    };

    return (
        <>
            <ScrutinyTab mainTabLabel="Scrutiny (Transfer DD/DNH)" />

            <Toast ref={toast} />
            <AppBreadcrumb currentMenu={'Scrutiny'} pageName={'Transfer To  DD/DNH  Scrutiny'} pageTitle={'Transfer To  DD/DNH  Scrutiny'} goToPage={true} />

            <div className="grid crud-demo mt-4">
                <div className="col-12">
                    <div className="card">
                        <div className="grid ">
                            <div className="field col-12 md:col-5">
                                <div className="flex mb-3">
                                    <b className="detail_title" style={{ minWidth: '100px' }}>
                                        Full Name :{' '}
                                    </b>
                                    <p className="detail_name">{name}</p>
                                </div>
                                <div className="flex mb-3">
                                    <b className="detail_title" style={{ minWidth: '100px' }}>
                                        App Status :
                                    </b>
                                    <p className="detail_name">{applicationDetails?.appStatus === 'Approved' ? <Badge value="Approved" severity="success"></Badge> : <Badge value={applicationDetails?.appStatus} severity="warning"></Badge>}</p>
                                </div>
                                <div className="flex">
                                    <b className="detail_title" style={{ minWidth: '100px' }}>
                                        Date :
                                    </b>
                                    <p className="detail_name">{!window.cn(applicationDetails?.EntDt) ? formatDate(applicationDetails?.EntDt) : ''}</p>
                                </div>
                            </div>
                            <div className="field  col-12 md:col-3">
                                <div className="flex mb-3">
                                    <b className="detail_title" style={{ minWidth: '100px' }}>
                                        File No :
                                    </b>
                                    <p className="detail_name">{applicationDetails?.SrNo}</p>
                                </div>
                                <div className="flex">
                                    <b className="detail_title" style={{ minWidth: '100px' }}>
                                        Verified By :
                                    </b>
                                    <p className="detail_name">{!window.cn(applicationDetails?.verified_by) ? applicationDetails?.verified_by : ''}</p>
                                </div>
                            </div>
                            <div className="field flex flex-column col-12 md:col-4 align-items-end">
                                <img
                                    src={applicationDetails?.Image}
                                    style={{
                                        border: '1px solid black'
                                    }}
                                    alt="User"
                                    width={'120px'}
                                />
                                <div className="flex mt-3">
                                    <Button label="Check Duplicate" className="mr-2" onClick={() => setDuplicateModal(true)}></Button>
                                    <Button label="View Document" onClick={() => viewDocuments()}></Button>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="card">
                        <FormWizard
                            stepSize="sm"
                            nextButtonTemplate={(handleNext) => (
                                <>
                                    <Button label="Next" onClick={handleNext} className="ml-2"></Button>
                                </>
                            )}
                            backButtonTemplate={(handlePrevious) => (
                                <>
                                    <Button label="Back" onClick={handlePrevious}></Button>
                                </>
                            )}
                            finishButtonTemplate={(handleComplete) => <></>}
                        >
                            <FormWizard.TabContent title="">
                                <div className="grid align-items-center">
                                    <div className="field col-12 md:col-8">
                                        <p className="scrutiny_data">1. Whether candidate is adove 18 years ? Mention birth date and place.</p>
                                    </div>
                                    <div className="field col-12 md:col-1">
                                        <Checkbox checked={scrutinyDetails?.BrthVld === 1 ? true : false} onChange={(e: any) => handleChange(e, 'BrthVld')}></Checkbox>
                                    </div>
                                    <div className="field col-12 md:col-3">
                                        <div className="flex">
                                            <p className="scrutiny_data">{!window.cn(applicationDetails.BOD) ? formatDate(applicationDetails.BOD) : ''}</p>
                                            <p className="scrutiny_data ml-2">{!window.cn(applicationDetails.PofBOD) ? applicationDetails.PofBOD : ''}</p>
                                        </div>
                                    </div>
                                </div>
                                <div className="grid align-items-center">
                                    <div className="field col-12 md:col-8">
                                        <p className="scrutiny_data">2. Whether the place of work / Residence is located in Gujarat : mention the Name of Place :</p>
                                    </div>
                                    <div className="field col-12 md:col-1">
                                        <Checkbox checked={scrutinyDetails?.ResLoc === 1 ? true : false} onChange={(e: any) => handleChange(e, 'ResLoc')}></Checkbox>
                                    </div>
                                    <div className="field col-12 md:col-3">
                                        <div className="flex">
                                            <p className="scrutiny_data"> {!window.cn(applicationDetails.PAddress) ? applicationDetails.PAddress : ''}</p>
                                        </div>
                                    </div>
                                </div>
                                <div className="grid align-items-center">
                                    <div className="field col-12 md:col-8">
                                        <p className="scrutiny_data">3. Whether the proof of residence is attacthed ? Ration card / Telephone Bill / Light Bill / Passport / other..</p>
                                    </div>
                                    <div className="field col-12 md:col-1">
                                        <Checkbox checked={scrutinyDetails?.ResProf === 1 ? true : false} onChange={(e: any) => handleChange(e, 'ResProf')}></Checkbox>
                                    </div>
                                </div>
                                <div className="grid align-items-center">
                                    <div className="field col-12 md:col-8">
                                        <p className="scrutiny_data">4. Document Uploaded :</p>
                                    </div>
                                    <div className="field col-12 md:col-1"></div>
                                    <div className="field col-12 md:col-3"></div>
                                </div>
                                <div className="grid align-items-center">
                                    <div className=" col-12 md:col-8">
                                        <p className="scrutiny_data ml-4">(A) School Leaving / Birth Certificate :</p>
                                    </div>
                                    <div className=" col-12 md:col-1">
                                        <Checkbox checked={scrutinyDetails?.SLertf === 1 ? true : false} onChange={(e: any) => handleChange(e, 'SLertf')}></Checkbox>
                                    </div>
                                    <div className=" col-12 md:col-3">
                                        <p className="scrutiny_data">{applicationDetails?.HSCSNm}</p>
                                    </div>
                                </div>
                                <div className="grid align-items-center">
                                    <div className=" col-12 md:col-8">
                                        <p className="scrutiny_data ml-4"> (B) New S.S.C / H.S.C Cretificate Marksheet :</p>
                                    </div>
                                    <div className=" col-12 md:col-1">
                                        <Checkbox checked={scrutinyDetails?.HScCertf === 1 ? true : false} onChange={(e: any) => handleChange(e, 'HScCertf')}></Checkbox>
                                    </div>
                                    <div className=" col-12 md:col-3">
                                        <p className="scrutiny_data">{applicationDetails?.HSCBrd}</p>
                                    </div>
                                </div>
                                <div className="grid align-items-center">
                                    <div className=" col-12 md:col-8">
                                        <p className="scrutiny_data ml-4"> (C) Degree / Diploma Marksheet</p>
                                    </div>
                                    <div className=" col-12 md:col-1">
                                        <Checkbox checked={scrutinyDetails?.DegMrksht === 1 ? true : false} onChange={(e: any) => handleChange(e, 'DegMrksht')}></Checkbox>
                                    </div>
                                    <div className=" col-12 md:col-3">
                                        <p className="scrutiny_data">{applicationDetails?.HSCYr}</p>
                                    </div>
                                </div>
                                <div className="grid align-items-center">
                                    <div className=" col-12 md:col-8">
                                        <p className="scrutiny_data ml-4">(D) Practical Training Certificate :</p>
                                    </div>
                                    <div className=" col-12 md:col-1">
                                        <Checkbox checked={scrutinyDetails?.TrainCertf === 1 ? true : false} onChange={(e: any) => handleChange(e, 'TrainCertf')}></Checkbox>
                                    </div>
                                </div>
                                <div className="grid align-items-center">
                                    <div className=" col-12 md:col-8">
                                        <p className="scrutiny_data ml-4">(E) College Passing Cert. / Original Reg. Certificate of other state :</p>
                                    </div>
                                    <div className=" col-12 md:col-1">
                                        <Checkbox checked={scrutinyDetails?.PorRCert === 1 ? true : false} onChange={(e: any) => handleChange(e, 'PorRCertf')}></Checkbox>
                                    </div>
                                </div>
                                <div className="grid align-items-center">
                                    <div className="field col-12 md:col-8">
                                        <p className="scrutiny_data ml-4">(F) Degree / Diploma Certificate in Pharmacy :</p>
                                    </div>
                                    <div className="field col-12 md:col-1">
                                        <Checkbox checked={scrutinyDetails?.DDInPhmcy === 1 ? true : false} onChange={(e: any) => handleChange(e, 'DDInPhmcy')}></Checkbox>
                                    </div>
                                </div>
                                <div className="grid align-items-center">
                                    <div className="field col-12 md:col-8">
                                        <p className="scrutiny_data"> 5. Details of college / Institute Qualification :</p>
                                    </div>
                                    <div className="field col-12 md:col-1">
                                        <Checkbox checked={scrutinyDetails?.Qualification === 1 || scrutinyDetails?.Qualification === '1' ? true : false} onChange={(e: any) => handleChange(e, 'Qualification')}></Checkbox>
                                    </div>
                                    <div className="field col-12 md:col-3">
                                        <p className="scrutiny_data">{applicationDetails?.DegNm}</p>
                                    </div>
                                </div>
                                <div className="grid align-items-center">
                                    <div className=" col-12 md:col-8">
                                        <p className="scrutiny_data ml-4">(A) State ( Mention Name ) :</p>
                                    </div>
                                    <div className=" col-12 md:col-1">
                                        <Checkbox checked={scrutinyDetails?.State === 1 || scrutinyDetails?.State === '1' ? true : false} onChange={(e: any) => handleChange(e, 'State')}></Checkbox>
                                    </div>
                                    <div className=" col-12 md:col-3">
                                        <p className="scrutiny_data"> {!window.cn(applicationDetails.collagemaster) ? applicationDetails.collagemaster.StateNm : ''}</p>
                                    </div>
                                </div>
                                <div className="grid">
                                    <div className=" col-12 md:col-8">
                                        <p className="scrutiny_data ml-4"> (B) Name and Address of college / Institute :</p>
                                    </div>
                                    <div className=" col-12 md:col-1">
                                        <Checkbox checked={scrutinyDetails?.ColNm === 1 || scrutinyDetails?.ColNm === '1' ? true : false} onChange={(e: any) => handleChange(e, 'ColNm')}></Checkbox>
                                    </div>
                                    <div className=" col-12 md:col-3">
                                        <p className="scrutiny_data">
                                            {' '}
                                            {!window.cn(applicationDetails?.collagemaster) ? (
                                                <div>
                                                    {applicationDetails?.collagemaster?.orgnameeng}
                                                    <br />
                                                    {applicationDetails?.collagemaster?.Address}
                                                </div>
                                            ) : (
                                                ''
                                            )}
                                        </p>
                                    </div>
                                </div>
                                <div className="grid align-items-center">
                                    <div className=" col-12 md:col-8">
                                        <p className="scrutiny_data ml-4"> (C) University Name and Place :</p>
                                    </div>
                                    <div className=" col-12 md:col-1">
                                        <Checkbox checked={scrutinyDetails?.UniNm === 1 ? true : false} onChange={(e: any) => handleChange(e, 'UniNm')}></Checkbox>
                                    </div>
                                    <div className=" col-12 md:col-3">
                                        <p className="scrutiny_data"> {!window.cn(applicationDetails?.collagemaster) ? applicationDetails?.collagemaster?.university : ''}</p>
                                    </div>
                                </div>
                                <div className="grid align-items-center">
                                    <div className=" col-12 md:col-8">
                                        <p className="scrutiny_data ml-4">(D) Month and Year of admission in the college :</p>
                                    </div>
                                    <div className=" col-12 md:col-1">
                                        <Checkbox checked={scrutinyDetails?.AdminYr === 1 ? true : false} onChange={(e: any) => handleChange(e, 'AdminYr')}></Checkbox>
                                    </div>
                                    <div className=" col-12 md:col-3">
                                        <p className="scrutiny_data"> {!window.cn(applicationDetails?.JoingYth) ? formatMonth(applicationDetails?.JoingYth) : ''}</p>
                                    </div>
                                </div>
                                <div className="grid align-items-center">
                                    <div className=" col-12 md:col-8">
                                        <p className="scrutiny_data ml-4">(E) Month and Year of Completion Of Study :</p>
                                    </div>
                                    <div className=" col-12 md:col-1">
                                        <Checkbox checked={scrutinyDetails?.PassYr === 1 ? true : false} onChange={(e: any) => handleChange(e, 'PassYr')}></Checkbox>
                                    </div>
                                    <div className=" col-12 md:col-3">
                                        <p className="scrutiny_data"> {!window.cn(applicationDetails?.Passedyth) ? formatMonth(applicationDetails?.Passedyth) : ''}</p>
                                    </div>
                                </div>
                                <div className="grid align-items-center">
                                    <div className=" col-12 md:col-8">
                                        <p className="scrutiny_data ml-4">(F) Whether Cretificate of College leaving / College Bonafied is attached. :</p>
                                    </div>
                                    <div className=" col-12 md:col-1">
                                        <Checkbox checked={false}></Checkbox>
                                    </div>
                                </div>
                                <div className="grid align-items-center">
                                    <div className=" col-12 md:col-8">
                                        <p className="scrutiny_data ml-4"> (G) Whether Provisional/ Original Certificate issued by the examining authority is attached :</p>
                                    </div>
                                    <div className=" col-12 md:col-1">
                                        <Checkbox checked={scrutinyDetails?.POrOExaAtt === 1 ? true : false} onChange={(e: any) => handleChange(e, 'POrOExaAtt')}></Checkbox>
                                    </div>
                                </div>
                            </FormWizard.TabContent>
                            <FormWizard.TabContent title="">
                                <div className="grid align-items-center">
                                    <div className="field col-12 md:col-12">
                                        <p className="scrutiny_data"> 6. Whether Course and Examination is approved by P.C.I inrespect of institutions _period mention under no (7) if yes mention :</p>
                                    </div>
                                </div>
                                <div className="field col-12 md:col-12">
                                    {/* Datatable */}
                                    <DataTable value={applicationDetails?.collageapproval} showGridlines stripedRows className="datatable-responsive " emptyMessage="No Data Found">
                                        <Column field="pcicirdt" header="Circular Date"></Column>
                                        <Column field="pcirefno" header="Reference No"></Column>
                                        <Column field="pciresno" header="Resolution No"></Column>
                                        <Column field="examautho" header="Examination Authority"></Column>
                                        <Column field="qualdateorg" header="Valid From"></Column>
                                        <Column field="qualdateorgf" header="Vaild To"></Column>
                                    </DataTable>
                                    {/* Datatable */}
                                </div>
                                <div className="grid align-items-center">
                                    <div className="field col-12 md:col-8">
                                        <p className="scrutiny_data"> 7. Whether Employers certificate / self declaration with required details attached</p>
                                    </div>
                                    <div className="field col-12 md:col-1">
                                        <Checkbox checked={scrutinyDetails?.EmpCertAttch === 1 ? true : false} onChange={(e: any) => handleChange(e, 'EmpCertAttch')}></Checkbox>
                                    </div>
                                </div>
                                <div className="grid align-items-center">
                                    <div className="field col-12 md:col-8">
                                        <p className="scrutiny_data"> 8. Whether the applicant is eligible for registration under section 32(2) of the Pharmacy Act 48</p>
                                    </div>
                                    <div className="field col-12 md:col-1">
                                        <Checkbox checked={scrutinyDetails?.AppEligible === 1 ? true : false} onChange={(e: any) => handleChange(e, 'AppEligible')}></Checkbox>
                                    </div>
                                </div>
                                <div className="grid align-items-center">
                                    <div className="field col-12 md:col-8">
                                        <p className="scrutiny_data">9. is eligible under Pharmacy amendment Act under 1976 Section 32(B)</p>
                                    </div>
                                    <div className="field col-12 md:col-1">
                                        <Checkbox checked={scrutinyDetails?.EligiblePhAct === 1 ? true : false} onChange={(e: any) => handleChange(e, 'EligiblePhAct')}></Checkbox>
                                    </div>
                                </div>
                            </FormWizard.TabContent>
                            <FormWizard.TabContent title="">
                                <div className="grid align-items-center">
                                    <div className="field col-12 md:col-8">
                                        <p className="scrutiny_data">1. State Council ( Mention Name Address )</p>
                                    </div>
                                    <div className="field col-12 md:col-1">
                                        <Checkbox checked={scrutinyDetails?.T17a === 1 ? true : false} onChange={(e: any) => handleChange(e, 'T17a')}></Checkbox>
                                    </div>
                                    <div className="field col-12 md:col-3">
                                        <div className="flex">
                                            <p className="scrutiny_data">{!window.cn(applicationDetails?.TRCounCilNm) ? applicationDetails?.TRCounCilNm : ''}</p>
                                        </div>
                                    </div>
                                </div>
                                <div className="grid align-items-center">
                                    <div className="field col-12 md:col-8">
                                        <p className="scrutiny_data">2. Registration No. & Date :</p>
                                    </div>
                                    <div className="field col-12 md:col-1">
                                        <Checkbox checked={scrutinyDetails?.T17b === 1 ? true : false} onChange={(e: any) => handleChange(e, 'T17b')}></Checkbox>
                                    </div>
                                    <div className="field col-12 md:col-3">
                                        <div className="flex">
                                            <p className="scrutiny_data">{applicationDetails?.TRegNo}</p>
                                            <p className="scrutiny_data ml-3">{!window.cn(applicationDetails?.TRegDt) ? formatDate(applicationDetails?.TRegDt) : ''}</p>
                                        </div>
                                    </div>
                                </div>
                                <div className="grid align-items-center">
                                    <div className="field col-12 md:col-8">
                                        <p className="scrutiny_data">3. Whether ' No Objection Certificate' received form concerned Pharmacy Council ? If Yes, mention letter No. and Date :</p>
                                    </div>
                                    <div className="field col-12 md:col-1">
                                        <Checkbox checked={scrutinyDetails?.T17h === 1 ? true : false} onChange={(e: any) => handleChange(e, 'T17h')}></Checkbox>
                                    </div>
                                    <div className="field col-12 md:col-3">
                                        <div className="flex">
                                            <InputText className="mr-1" value={scrutinyDetails?.LtrNo} name="LtrNo" onChange={(e) => handleNoteChange(e, 'LtrNo')} placeholder="Letter No" style={{ maxWidth: '60%', width: '60%' }}></InputText>
                                            <Calendar
                                                value={date}
                                                dateFormat="MM dd yy"
                                                onChange={(e: any) => {
                                                    handleChangeDate(e.value);
                                                }}
                                                showIcon
                                                placeholder="mm/dd/yy"
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="grid align-items-center">
                                    <div className="field col-12 md:col-8">
                                        <p className="scrutiny_data">4. Whether the applicant found eligible for transfer of registration under the Section 32(2) of the pharmacy Act as per latest instruction Of PCI ?</p>
                                    </div>
                                    <div className="field col-12 md:col-1 ">
                                        <Checkbox checked={scrutinyDetails?.T17J === 1 ? true : false} onChange={(e: any) => handleChange(e, 'T17J')}></Checkbox>
                                    </div>
                                </div>
                                <div className="grid">
                                    <div className="field col-12 md:col-8">
                                        {roleName === 'Scrutiny Manager' ? (
                                            <>
                                                <div className="field scrutiny-note-div">
                                                    <label htmlFor="Note">Prepared Note :</label>
                                                    <InputTextarea value={scrutinyDetails?.PNote} name="PNote" onChange={(e) => handleNoteChange(e, 'PNote')} rows={4}></InputTextarea>
                                                </div>

                                                <div className="scrutiny-note-label">
                                                    {' '}
                                                    <label>
                                                        Check Note : &nbsp;
                                                        {scrutinyDetails?.CNote}
                                                    </label>
                                                    <label>
                                                        Approval Note : &nbsp;
                                                        {scrutinyDetails?.ANote}
                                                    </label>
                                                    {!window.cn(scrutinyDetails?.prepared_by) && (
                                                        <>
                                                            <br />

                                                            <label>
                                                                Prepared By : &nbsp;
                                                                {scrutinyDetails?.prepared_by}&nbsp;&nbsp;&nbsp;
                                                                {convertDateTime(scrutinyDetails?.prepared_time)}
                                                            </label>
                                                        </>
                                                    )}
                                                </div>
                                            </>
                                        ) : (
                                            ''
                                        )}

                                        {roleName === 'Sub Registar' ? (
                                            <>
                                                <div className="field scrutiny-note-div">
                                                    <label htmlFor="Note">Check Note :</label>
                                                    <InputTextarea value={scrutinyDetails?.CNote} name="CNote" onChange={(e) => handleNoteChange(e, 'CNote')} rows={4}></InputTextarea>
                                                </div>
                                                <div className="scrutiny-note-label">
                                                    <label>
                                                        Prepared Note : &nbsp;
                                                        {scrutinyDetails?.PNote}
                                                    </label>
                                                    <label>
                                                        Approval Note : &nbsp;
                                                        {scrutinyDetails?.ANote}
                                                    </label>

                                                    {!window.cn(scrutinyDetails?.prepared_by) && (
                                                        <>
                                                            <br />

                                                            <label>
                                                                Prepared By : &nbsp;
                                                                {scrutinyDetails?.prepared_by}&nbsp;&nbsp;&nbsp;
                                                                {convertDateTime(scrutinyDetails?.prepared_time)}
                                                            </label>
                                                        </>
                                                    )}
                                                    {!window.cn(scrutinyDetails?.checked_by) && (
                                                        <>
                                                            <label>
                                                                Checked By : &nbsp;
                                                                {scrutinyDetails?.checked_by}&nbsp;&nbsp;&nbsp;
                                                                {convertDateTime(scrutinyDetails?.checked_time)}
                                                            </label>
                                                        </>
                                                    )}
                                                    {!window.cn(scrutinyDetails?.approved_by) && (
                                                        <>
                                                            <label>
                                                                Approved By : &nbsp;
                                                                {scrutinyDetails?.approved_by}&nbsp;&nbsp;&nbsp;
                                                                {convertDateTime(scrutinyDetails?.approved_time)}
                                                            </label>
                                                        </>
                                                    )}
                                                </div>
                                            </>
                                        ) : (
                                            ''
                                        )}

                                        {roleName === 'Registar' ? (
                                            <>
                                                <div className="field scrutiny-note-div">
                                                    <label htmlFor="Note">Approval Note :</label>
                                                    <InputTextarea value={scrutinyDetails?.ANote} name="ANote" onChange={(e) => handleNoteChange(e, 'ANote')} rows={4}></InputTextarea>
                                                </div>
                                                <div className="scrutiny-note-label">
                                                    <label>
                                                        {' '}
                                                        Prepared Note : &nbsp;
                                                        {scrutinyDetails?.PNote}
                                                    </label>
                                                    <label>
                                                        {' '}
                                                        Check Note : &nbsp;
                                                        {scrutinyDetails?.CNote}
                                                    </label>

                                                    {!window.cn(scrutinyDetails?.prepared_by) && (
                                                        <>
                                                            <br />

                                                            <label>
                                                                Prepared By : &nbsp;
                                                                {scrutinyDetails?.prepared_by}&nbsp;&nbsp;&nbsp;
                                                                {convertDateTime(scrutinyDetails?.prepared_time)}
                                                            </label>
                                                        </>
                                                    )}
                                                    {!window.cn(scrutinyDetails?.checked_by) && (
                                                        <>
                                                            <label>
                                                                Checked By : &nbsp;
                                                                {scrutinyDetails?.checked_by}&nbsp;&nbsp;&nbsp;
                                                                {convertDateTime(scrutinyDetails?.checked_time)}
                                                            </label>
                                                        </>
                                                    )}
                                                    {!window.cn(scrutinyDetails?.approved_by) && (
                                                        <>
                                                            <label>
                                                                Approved By : &nbsp;
                                                                {scrutinyDetails?.approved_by}&nbsp;&nbsp;&nbsp;
                                                                {convertDateTime(scrutinyDetails?.approved_time)}
                                                            </label>
                                                        </>
                                                    )}
                                                </div>
                                            </>
                                        ) : (
                                            ''
                                        )}
                                    </div>

                                    <div className="field col-12 md:col-2 mt-5" style={{ marginLeft: '3%' }}>
                                        {roleName == 'Scrutiny Manager' ? (
                                            <>
                                                <div className="field-checkbox">
                                                    <Checkbox inputId="checkOption1" checked={scrutinyDetails?.Preparedby === 1 ? true : false} onChange={(e: any) => handleChange(e, 'Preparedby')}></Checkbox>
                                                    <label htmlFor="checkOption1">Prepared</label>
                                                </div>
                                            </>
                                        ) : (
                                            ''
                                        )}

                                        {roleName == 'Sub Registar' ? (
                                            <>
                                                <div className="field-checkbox">
                                                    <Checkbox inputId="checkOption2" checked={scrutinyDetails?.Checkby === 1 ? true : false} onChange={(e: any) => handleChange(e, 'Checkby')}></Checkbox>
                                                    <label htmlFor="checkOption2">Check</label>
                                                </div>
                                            </>
                                        ) : (
                                            ''
                                        )}
                                        {roleName == 'Registar' ? (
                                            <>
                                                <div className="field-checkbox">
                                                    <Checkbox inputId="checkOption3" checked={scrutinyDetails?.Approvedby === 1 ? true : false} onChange={(e: any) => handleChange(e, 'Approvedby')}></Checkbox>
                                                    <label htmlFor="checkOption3">Approval</label>
                                                </div>
                                            </>
                                        ) : (
                                            ''
                                        )}
                                    </div>
                                </div>
                            </FormWizard.TabContent>
                        </FormWizard>

                        <div className="grid justify-content-between w-100 px-5">
                            <div>
                                {roleName === 'Scrutiny Manager' && activeIndex === 0 ? (
                                    <Button label=" Verification" onClick={() => setOpenVerificationDialog(true)}></Button>
                                ) : (
                                    <Button
                                        label="Verification List"
                                        tooltip={scrutinyDetails?.verification_status === 0 ? "In this file don't have any verification" : ''}
                                        tooltipOptions={{ position: 'top' }}
                                        disabled={scrutinyDetails?.verification_status === 0 ? true : false}
                                        onClick={() => viewVerificationList(scrutinyDetails?.EntryNo, 'scrutinyInner')}
                                        className="mr-2"
                                    ></Button>
                                )}

                                {(roleName === 'Sub Registar' && activeIndex === 1) || (roleName === 'Registar' && activeIndex === 2) ? <Button label="Send to Verification Scrutiny" onClick={() => setApproveConfirmDialog(true)}></Button> : null}
                            </div>

                            <div>
                                {(roleName === 'Registar' && activeIndex === 2) || activeIndex === 3 ? (
                                    <>
                                        <Button label={applicationDetails?.appStatus === 'Scrutiny Check' ? 'Hold Scrutiny' : 'Unhold Scrutiny'} onClick={() => setScrutinyHoldDialog(true)} />
                                        <Button label="Permanent Close" onClick={() => setScruitnyPermanentCloseDialog(true)} className="ml-2 p-button p-button-danger" />
                                    </>
                                ) : null}
                                {applicationDetails !== undefined &&
                                (applicationDetails?.RegNo == 'null' || applicationDetails?.RegNo == null) &&
                                ((roleName === 'Scrutiny Manager' && activeIndex === 0) || (roleName === 'Sub Registar' && activeIndex === 1) || (roleName === 'Registar' && activeIndex === 2)) ? (
                                    <Button label="Save" className="ml-2 p-button p-button-success" onClick={roleName === 'Registar' ? () => openCertificateModal() : () => saveScrutiny()} loading={saveButtonLoader} />
                                ) : (
                                    <Button label="Save" disabled tooltip="Already RegNo is assigned / Don't have access" tooltipOptions={{ position: 'top' }} className="ml-2 p-button p-button-success" />
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Duplicate Modal Start */}

            <Dialog visible={duplicateModal} style={{ width: '750px' }} header={'Duplicate Data'} modal onHide={hideDuplicateDialog}>
                <div className="p-2">
                    <DataTable value={duplicateData} emptyMessage="No Data Found">
                        <Column field="SrNo" header="SrNo"></Column>
                        <Column field="RegNo" header="Reg No"></Column>
                        <Column field="BOD" header="DOB" body={dateTemplate}></Column>
                        <Column field="name" header="Name" body={combinedFullNameTemplate}></Column>
                    </DataTable>
                </div>
            </Dialog>
            {/* Duplicate Modal End */}

            {/* Duplicate Modal Start */}
            <Dialog
                visible={certificateDialog}
                style={{ width: '550px' }}
                header={'Select Certificate'}
                modal
                onHide={hideCertificateModal}
                footer={
                    <>
                        <Button label="Cancel" icon="pi pi-times" className="p-button-secondary" onClick={() => hideCertificateModal()} />
                        <Button label="Submit" icon="pi pi-check" onClick={() => saveScrutiny()} loading={saveButtonLoader} />
                    </>
                }
            >
                <div className="grid ">
                    <div className="field col-12 md:col-12">
                        <div className="field ">
                            <label htmlFor="customer_type">
                                <b>Select Certificate</b>
                            </label>
                            <div className="grid mt-1 ml-1">
                                <div className="field-radiobutton mb-0">
                                    <RadioButton inputId="certi" name="option" value="Provisional" checked={selectedCertificate === 'Provisional'} onChange={(e) => onCertificateChange(e.value)} />
                                    <label htmlFor="certi">Provisional</label>
                                </div>

                                <div className="field-radiobutton ml-4 mb-0">
                                    <RadioButton inputId="certi2" name="option" value="Original" checked={selectedCertificate === 'Original'} onChange={(e) => onCertificateChange(e.value)} />
                                    <label htmlFor="certi2">Original</label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Dialog>
            {/* Duplicate Modal End */}

            {/* Scrutiny hold Modal Start */}

            <Dialog visible={duplicateModal} style={{ width: '750px' }} header={'Duplicate Data'} modal onHide={hideDuplicateDialog}>
                <div className="p-2">
                    <DataTable value={duplicateData} emptyMessage="No Data Found">
                        <Column field="SrNo" header="SrNo"></Column>
                        <Column field="RegNo" header="Reg No"></Column>
                        <Column field="BOD" header="DOB" body={dateTemplate}></Column>
                        <Column field="name" header="Name" body={combinedFullNameTemplate}></Column>
                    </DataTable>
                </div>
            </Dialog>
            {/* Scrutiny hold Modal End */}
            {scrutinyHoldDialog === true && (
                <ScrutinyHoldModal
                    openmodel={scrutinyHoldDialog}
                    dismissClick={() => hideScrutinyHoldDialog()}
                    srNo={atob(fileNo)}
                    status={applicationDetails.appStatus == 'Scrutiny Check' ? 'Scrutiny Hold' : 'Scrutiny Check'}
                    activeIndex={btoa(activeIndex)}
                    appName={transferApplicationName}
                />
            )}
            {/* Scrutiny permanent close Modal End */}
            {scruitnyPermanentCloseDialog === true && (
                <ScrutinyPermanentCloseModal openmodel={scruitnyPermanentCloseDialog} dismissClick={() => hideScrutinyPermanentCloseDialog()} fileNo={atob(fileNo)} activeIndex={btoa(activeIndex)} appName={transferApplicationName} />
            )}

            {/* Scrutiny Success Modal Start */}
            {!window.cn(successDetails) && successDialog === true && <ScrutinySuccessModal openmodel={successDialog} title={'Fresh Registration Scrutiny'} goToApp={() => goToApp()} data={{ fileNo, roleName, name, successDetails }} />}

            {/* Scrutiny Success Modal end */}

            {/* Scrutiny Verification Modal Start */}
            {openVerificationDialog === true && (
                <ScrutinyVerificationModal
                    openmodel={openVerificationDialog}
                    dismissClick={() => closeVerificationModal()}
                    data={{
                        fileNo: fileNo,
                        freshApplicationNo: transfertoDDDNH,
                        freshApplicationName: transferApplicationName,
                        applicationDetails: applicationDetails
                    }}
                />
            )}
            {/* Scrutiny Verification Modal end */}

            {/* Approve Confirm Modal Start */}
            <Dialog
                visible={approveConfirmDialog}
                className="p-fluid"
                style={{ width: '650px' }}
                header="Approve Application"
                modal
                draggable={false}
                resizable={false}
                footer={
                    <>
                        <Button label="Cancel" icon="pi pi-times" className="p-button-secondary" onClick={() => closeApproveConfirmDialog()} />
                        <Button label="Submit" icon="pi pi-check" className="p-button-primary" onClick={() => sendToVerification()} loading={approveBtnLoader} />
                    </>
                }
                onHide={() => closeApproveConfirmDialog()}
            >
                <h5 className="bold">Are you sure you want to send this application in verification scrutiny ?</h5>
            </Dialog>
            {/* Approve Confirm Modal End */}

            {/* Loader */}
            {pageLoad && <Loader />}
        </>
    );
};
